import jsonp from 'jsonp';
import { useState, type FC } from 'react';
import { toast } from 'react-toastify';

const MAILCHIMP_URL =
  'https://gmail.us22.list-manage.com/subscribe/post?u=8ccc8f15fc3b326036799a0cd&id=d1651fcb4b&f_id=008dc4e1f0';

type SubscribeBoxProps = {
  className?: string;
  title?: string;
  description?: string;
  disclaimer?: string;
};

const SubscribeBox: FC<SubscribeBoxProps> = ({
  className = '',
  title = 'Stay Ahead',
  description = 'Receive the latest technical whitepapers and engineering updates directly in your inbox.',
  disclaimer = 'By subscribing, you agree to our privacy policy regarding data handling.',
}) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  return (
    <div
      className={`pointer-events-auto relative z-30 bg-gradient-to-b from-[#d55a19] to-[#9d1c12] px-6 py-8 text-white sm:px-10 sm:py-10 ${className}`}
    >
      <p
        className="text-xl font-semibold sm:text-[26.95px] sm:leading-[37.73px]"
        style={{
          fontFamily: 'Inter',
          letterSpacing: '0px',
        }}
      >
        {title}
      </p>
      <p
        className="mt-4 opacity-95"
        style={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '120%',
          letterSpacing: '0px',
        }}
      >
        {description}
      </p>

      <form
        className="relative z-30 mt-8 space-y-5"
        onSubmit={(ev) => {
          ev.preventDefault();
          if (!email.trim()) {
            toast.error('Please enter your email');
            return;
          }
          setLoading(true);
          jsonp(
            `${MAILCHIMP_URL}&EMAIL=${encodeURIComponent(email)}`,
            { param: 'c' },
            (_, data: { msg: string; result: 'success' | 'error' }) => {
              const { msg, result } = data;
              setLoading(false);
              if (result === 'error') {
                toast.error(msg.replace('0 -', ''));
                return;
              }
              toast.success(msg);
              setEmail('');
            },
          );
        }}
      >
        <input
          className="w-full bg-white/10 px-5 py-4 text-base text-white placeholder-white/60 outline-none ring-1 ring-white/20 focus:ring-white/40"
          name="EMAIL"
          onChange={(ev) => setEmail(ev.target.value)}
          placeholder="Professional Email"
          type="email"
          value={email}
        />

        <button
          className="blog-subscribe-btn w-full cursor-pointer bg-white py-4 text-sm font-semibold tracking-widest disabled:cursor-not-allowed disabled:opacity-70"
          disabled={loading}
          type="submit"
        >
          <span
            style={{
              backgroundImage:
                'linear-gradient(108.74deg, #990400 0%, #FF8A00 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {loading ? 'PLEASE WAIT' : 'SUBSCRIBE'}
          </span>
        </button>
      </form>

      <p
        className="mt-6 opacity-80"
        style={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '12.35px',
          lineHeight: '19.77px',
          letterSpacing: '-0.62px',
          textTransform: 'uppercase',
        }}
      >
        {disclaimer}
      </p>
    </div>
  );
};

export default SubscribeBox;
